import React from "react";
import {
  EmailShareButton,
  WhatsappShareButton,

  WhatsappIcon,
  EmailIcon,
} from 'react-share';

import {
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";


const SocialShare = (props) => {
  const { title, path, excerpt } = props;
  const shareUrl = `https://howtovietnamese.com${path}`;
  return (
    <div className="share-wrapper">
      <div className="share-inner">
        <button
          title="Share on Facebook"
          onClick={() =>
            share(
              "https://www.facebook.com/sharer/sharer.php?u=",
              title,
              path,
              excerpt
            )
          }
          className="social-button facebook-button"
        >
          <FaFacebook />
        </button>
        <button
          onClick={() =>
            twitter("https://twitter.com/share?url=", title, path, excerpt)
          }
          data-tags="Tags"
          title="Share on Twitter"
          className="social-button twitter-button"
        >
          <FaTwitter />
        </button>
        {/*
        <TelegramShareButton
          url={shareUrl}
          title={title}
          className="social-button telegram-button">
          <TelegramIcon size={32} round />
        </TelegramShareButton>
        */}
        <WhatsappShareButton
          url={shareUrl}
          title={title}
          separator=":: "
          className="social-button whatsapp-button"
        >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        <EmailShareButton
          url={shareUrl}
          subject={title}
          body={excerpt}
          className="social-button email-button"
        >
          <EmailIcon size={32} round />
        </EmailShareButton>
      </div>
    </div>
  );
};

const wSize = "width=600,height=460";
// URLs array
const share = (url, title, path, excerpt) => {
  const loc = encodeURIComponent("https://howtovietnamese.com" + path);
  window.open(url + loc, title, wSize);
};
const twitter = (url, title, path, excerpt) => {
  const via = "via=elingos";
  const loc = encodeURIComponent("https://howtovietnamese.com" + path);
  // todo: make it mpre dinamic
  const text = encodeURIComponent(excerpt);
  const hashtag = "hashtags=vietnamese,howtovietnamese,learning,languages";
  window.open(
    url + loc + "&text=" + text + "&" + hashtag + "&" + via,
    title,
    wSize
  );
};


export default SocialShare;
